
import Cookies from 'js-cookie';

export function cookieAdd(name, value, expires) {
  let domain = '.partner-s.net';
  Cookies.set(name, value, {domain:domain, expires:expires , path:'/'});
  return true;
}

export function cookieDel(name) {
  let domain = '.partner-s.net';
  //Cookies.remove(name, { path: '/' })
  Cookies.set(name, null, {domain:domain, expires:0, path:'/'});
  return true;
}
